const generateColorCode = () => {
    const randomColorCode 
      = Math.floor(Math.random() * 16777215).toString(16);
    return`#${randomColorCode}`;
  }
  
  export default generateColorCode;